import { HttpClient } from '@angular/common/http';
import { Identifiers } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_SETTINGS, SCAMP_API } from 'src/environments/environment';
import { CommandResult } from '../pages/domain/commandResult';
import { Local, TipoMaterial } from '../pages/domain/domain.model';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class TipoMaterialService {

  constructor(
    private http: HttpClient,
    private account: AccountService
  ) { }


  getAll(): Observable<TipoMaterial[]> {
    return this.http.get<TipoMaterial[]>(`${SCAMP_API.accountApiV1}/tipos-materiais`,
      { headers: this.account.composeHeaders() });
  }

  getById(id: number): Observable<TipoMaterial> {
    return this.http.get<TipoMaterial>(`${SCAMP_API.accountApiV1}/tipos-materiais/${id}`,
      { headers: this.account.composeHeaders() });
  }

  post(tipoMaterial: TipoMaterial): Observable<CommandResult> {
    return this.http.post<CommandResult>(`${SCAMP_API.accountApiV1}/tipos-materiais`,
      tipoMaterial, { headers: this.account.composeHeaders() });
  }


  remove(id: number): Observable<CommandResult> {
    return this.http.delete<CommandResult>(`${SCAMP_API.accountApiV1}/tipos-materiais/${id}`,
      { headers: this.account.composeHeaders() })
  }

  alreadyRegistered(id: number, descricao: string): Observable<boolean> {
    return this.http.get<boolean>(`${SCAMP_API.accountApiV1}/tipos_materiais/descricao-ja-cadastrada/${id}/${descricao}`,
      { headers: this.account.composeHeaders() }
    )

  }


}
